/**
 * 浅色页面背景的浮动光斑（参考 EcommerceReplicate 视觉语言）
 *
 * 用于 director 模式的列表页 / 工作台页 / 分享落地页背景装饰
 * 不接受 props，固定三个色斑位置
 */

import { directorStyle } from './styleTokens';

export function PageBlobs() {
  return (
    <div className={directorStyle.pageBlur}>
      <div className="absolute -top-28 left-[18%] h-80 w-80 rounded-full bg-sky-200/50 blur-3xl" />
      <div className="absolute right-[-8%] top-40 h-96 w-96 rounded-full bg-cyan-200/40 blur-3xl" />
      <div className="absolute bottom-[-12%] left-[42%] h-96 w-96 rounded-full bg-amber-100/60 blur-3xl" />
    </div>
  );
}
